'use client'

import {MinimalGameDetail} from '@app/api/games/get-games-list'
import CardSquare from '@app/components/game-cards/square'
import {HomePageSections} from '@app/components/home-page-sections/analytics/types'
import {LanguageCodes} from '@app/i18n/settings'
import PlaceholderCard from './placeholder-card'
import {ReactNode, useEffect, useState} from 'react'
import {usePathname} from 'next/navigation'
import {fetchLastPlayedAction} from './fetchLastPlayedAction'
import CardHorizontal from '@app/components/game-cards/horizontal'
import s from './style.module.scss'
import clsx from 'clsx'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'

type Props = {
  lang: LanguageCodes
  placeholderCss?: string
  additionalAttributes?: Record<string, any>
  isMobile: boolean
  propertyCode: string
  games: MinimalGameDetail[]
  placeholder: ReactNode
  reffererLayout?: ReffererLayout
}

const ContinuePlayingSliderClient = ({
  lang,
  placeholderCss = '',
  additionalAttributes,
  games,
  isMobile,
  propertyCode,
  placeholder,
  reffererLayout,
}: Props) => {
  const path = usePathname()
  const [lastplayedGames, setlastplayedGames] = useState(games)

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const {lastPlayedGames} = await fetchLastPlayedAction({
          isSearchSection: !!additionalAttributes,
          lang,
        })
        setlastplayedGames(lastPlayedGames)
      } catch (error) {
        console.error('error fetching last played games by action', error)
      }
    }
    fetchGames()
  }, [path])

  return (
    <>
      {placeholder}
      {lastplayedGames.map((game) => (
        <CardHorizontal
          key={game.code}
          gameCode={game.code}
          gameName={game.name}
          gameNameEn={game.nameEn}
          propertyCode={propertyCode}
          additionalAttributes={additionalAttributes}
          layout={HomePageSections.ContinuePlaying}
          className={clsx(s.dimentions, {
            [s.desktop_card_dimensions]: !isMobile,
          })}
          reffererLayout={reffererLayout}
        />
      ))}
    </>
  )
}

export default ContinuePlayingSliderClient
